import logo from './logo.svg';
import './App.css';
import Home from './Components/Home.jsx';  

function App() {
  return (
    <div className="App">
      <Home />   {/* Capitalized */}
    </div>
  );
}

export default App;